import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {
  errorStateBackBtnParams,
  ErrorStateCode,
  errorStateCodeImage,
  errorStateCodeTitle,
  errorStateSubmitBtnParams,
} from './error-state.type';
import { AppButtonComponent } from '@/components/button/app-button.component';
import { ROUTES } from '@/consts/routes.const';
import { DeviceType } from '../../services/breakpoint/breakpoint.service';
import { PATH_IMAGES_SVG } from '../../consts/paths';

@Component({
  selector: '.view-error-state',
  imports: [AppButtonComponent, RouterLink, NgTemplateOutlet],
  templateUrl: './error-state.component.html',
  styleUrl: './error-state.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-test-id]': 'testId()',
    '[attr.data-device-type]': 'deviceType()',
  },
  standalone: true,
})
export class ErrorStateComponent {
  #router = inject(Router);

  code = input<ErrorStateCode>('notFound');
  deviceType = input<DeviceType>('mobile');
  testId = input('', { transform: (testId: string) => testId + '--view-error-state' });

  img = computed(() => `/${PATH_IMAGES_SVG}${errorStateCodeImage[this.code()]}`);
  title = computed(() => errorStateCodeTitle[this.code()]);
  backBtnParams = computed(() => errorStateBackBtnParams[this.code()]);
  submitBtnParams = computed(() => errorStateSubmitBtnParams[this.code()]);

  codesWithAdditionalText: ErrorStateCode[] = ['forbidden', 'notFound', 'internalServerError'];

  login(): void {
    this.#router.navigateByUrl(ROUTES.login).then();
  }

  handleSubmitBtn(): void {
    const code = this.code();

    if (this.codesWithAdditionalText.includes(code)) {
      this.#router.navigateByUrl(ROUTES.home).then();
    } else if (code === 'serviceUnavailable') {
      this.#router.navigateByUrl('./').then();
    } else if (code === 'unauthorized') {
      this.login();
    }
  }

  handleBackBtn(): void {
    const code = this.code();

    if (code === 'forbidden') {
      this.login();
    } else if (['notFound', 'internalServerError'].includes(code)) {
      this.#router.navigateByUrl('./').then();
    }
  }
}
